import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="8" height="3" transform="matrix(1 0 0 -1 2.5 9.24609)" className="row-fill" fill="currentColor" />
    <rect width="19" height="3" transform="matrix(1 0 0 -1 11.5 9.24609)" className="row-fill" fill="currentColor" />
    <rect width="8" height="3" transform="matrix(1 0 0 -1 2.5 15.2461)" className="alt-fill" fill="currentColor" />
    <rect width="19" height="3" transform="matrix(1 0 0 -1 11.5 15.2461)" className="alt-fill" fill="currentColor" />
    <rect width="8" height="3" transform="matrix(1 0 0 -1 2.5 21.2461)" className="alt-fill" fill="currentColor" />
    <rect width="19" height="3" transform="matrix(1 0 0 -1 11.5 21.2461)" className="alt-fill" fill="currentColor" />
    <rect width="8" height="1" transform="matrix(1 0 0 -1 2.5 25.2461)" className="row-fill" fill="currentColor" />
    <rect width="19" height="1" transform="matrix(1 0 0 -1 11.5 25.2461)" className="row-fill" fill="currentColor" />
  </svg>,
  'TableIcon'
);

export const TableIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.row-fill': {
          color: theme.palette.status.success.highContrast,
        },
        '.alt-fill': {
          color: theme.palette.status.success.main,
        },
      })}
    />
  );
};
